import { render, staticRenderFns } from "./SubjectText.vue?vue&type=template&id=3660eba5&"
import script from "./SubjectText.vue?vue&type=script&lang=js&"
export * from "./SubjectText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports